<template>
  <div class="page_content job-applicants-page">
    <job-header :uuid="uuid"></job-header>
    <div class="course-management-section">
      <div class="pg_toolbar applicants-toolbar">
        <div class="toolbar-left">
          <h2 class="head_txt module_type_name ace_sec_hd">{{ $t('applicants') }} [{{ filteredApplications.length }}]</h2>
          <div class="applicants-filters">
            <b-button @click.stop="toggleFiltersDropDown" id="applicantsStatusDropDown" class="form-field applicant-status-filter ace_sec" tabindex="0">
              <span class="txt_sh">{{ $t('selectStatus') }}</span>
              <span class="icon-dropdown1"></span>
            </b-button>
            <div id="applicantsFiltersPopup" class="explore_filter_container"></div>
            <b-popover target="applicantsStatusDropDown" :show.sync="showFiltersDropDown" container="applicantsFiltersPopup" triggers="blur">
              <div class="field-row" v-for="statusValue in statusArray" :key="'filter-' + statusValue">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" :id="'applicant-filter-' + statusValue" :value="statusValue" v-model="statusFilterDraft" @click.stop @input.stop>
                  <label class="form-check-label" :for="'applicant-filter-' + statusValue">{{ statusValue }}</label>
                </div>
              </div>
              <b-btn @click="filtersOkClicked" class="range-button">{{ $t('ok') }}</b-btn>
            </b-popover>
          </div>
        </div>
        <div class="toolbar-right">
          <!--
          <div class="out-of-total-item ace_sec_txt">
            <div>{{ filteredApplications.length }} {{ $t('applicants').toLowerCase() }}</div>
          </div>
          -->
          <div class="number-of-item ace_sec_txt">
            <b-dropdown id="applicantsSizeDropdown" :text="'' + pageSize" :aria-label="$t('numberOfItem')">
              <template v-for="(option, index) in sizeOptions">
                <b-dropdown-divider v-if="index > 0" :key="'divider-' + option"></b-dropdown-divider>
                <b-dropdown-item :key="'size-' + option" @click="changeSize(option)">{{ option }} {{ $t('itemPerPage') }}</b-dropdown-item>
              </template>
            </b-dropdown>
          </div>
          <div class="pagination btn_container pagination_sty3">
            <button type="button" class="btn btn_trans" :disabled="firstPage" @click="prev" @keydown.enter="prev" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
            <span class="current-page ace_sec_txt">{{ page + 1 }}</span>
            <button type="button" class="btn btn_trans" :disabled="lastPage" @click="next" @keydown.enter="next" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
          </div>

          <div class="search-box-container">
            <input type="text" class="input-search" :placeholder="$t('typeToNarrowResults')" v-on:keypress.enter="searchButtonClicked" v-model.trim="searchTerms" :aria-label="$t('typeToNarrowResults')">
            <button class="btn btn_srh" @click="searchButtonClicked" :aria-label="$t('goAria')">
              <span class="ic_srh ic_search" aria-hidden="true"></span>
            </button>
            <button id="applicantsSortByDropDown" type="button" @click="toggleSortByDropDown" class="sort-by ace_sec">
              <span class="ic2_sort2 sort-by-icon" aria-hidden="true"></span>
              <span class="txt_srt">{{ $t('sort') }}</span>
            </button>
            <div id="applicantsSortPopup" class="sort_by_popover"></div>
          </div>
          <b-popover target="applicantsSortByDropDown" :show.sync="showSortByDropDown" container="applicantsSortPopup" triggers="blur">
            <div class="header-content-row">
              <span class="title">{{ $t('sortBy') }}</span>
            </div>
            <template v-for="sort in sorts">
              <div class="field-row" :key="sort.name">
                <div class="form-check">
                  <input type="radio" class="form-check-input" :id="'applicant-sort-' + sort.name" v-model="selectedSortName" :value="sort.name">
                  <label class="form-check-label" :for="'applicant-sort-' + sort.name">{{ sort.labelKey ? $t(sort.labelKey) : sort.name }}</label>
                </div>
              </div>
            </template>
            <b-btn @click="sortOkClicked" class="range-button">{{ $t('ok') }}</b-btn>
          </b-popover>
        </div>
      </div>

      <div class="applicants-body">
        <div class="applicants-list-pane">
          <div v-if="pagedApplications.length > 0" class="applicants-list">
            <div
              class="applicant-row"
              v-for="(application, index) in pagedApplications"
              :key="application.uuid || application.userId || index"
              :class="{ 'is-selected': isSelected(application) }"
              @click="selectApplication(application)">
              <div class="applicant-name-row">
                <div class="applicant-avatar" :style="{ background: avatarColor(index) }">
                  <span class="icon-user"></span>
                </div>
                <div class="applicant-name ace_sec_txt">{{ application.userFullName }}</div>
              </div>
              <div class="applicant-institution" v-if="institutionTitle(application) || institutionLogo(application)">
                <div
                  class="institution-avatar"
                  :class="{ 'has-logo': institutionLogo(application) }"
                  :style="institutionLogo(application) ? null : { background: avatarColor(index + 1) }">
                  <img
                    v-if="institutionLogo(application)"
                    :src="institutionLogo(application)"
                    :alt="institutionTitle(application)">
                  <span v-else>{{ institutionInitials(institutionTitle(application)) }}</span>
                </div>
                <div class="institution-name ace_sec_txt">{{ institutionTitle(application) }}</div>
              </div>
              <div class="applicant-status-row">
                <span class="status-path-icon" aria-hidden="true">
                  <span class="ic2_Process"></span>
                </span>
                <div class="status-boxes">
                  <div
                    class="status-box"
                    v-for="stage in statusStages"
                    :key="stage.key"
                    :class="{
                      'is-complete': isStageComplete(application, stage),
                      'is-rejected': isStageRejected(application, stage)
                    }"
                    :title="stageDisplayLabel(application, stage)"
                    :aria-label="stageDisplayLabel(application, stage)">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="no-result ace_sec_txt" style="text-align: center;">{{ $t('noResult') }}</div>
        </div>
        <div class="applicants-details-pane">
          <template v-if="selectedApplication">
            <div class="details-header">
              <div class="details-applicant">
                <div class="applicant-avatar details-user-avatar" :style="{ background: avatarColor(selectedApplicantIndex) }">
                  <span class="icon-user"></span>
                </div>
                <span class="details-applicant-name ace_sec_txt">{{ selectedApplication.userFullName }}</span>
              </div>
              <div class="details-tabs" role="tablist">
                <button
                  type="button"
                  class="details-tab"
                  :class="{ 'is-active': detailsTab === 'status' }"
                  role="tab"
                  :aria-selected="detailsTab === 'status' ? 'true' : 'false'"
                  @click="detailsTab = 'status'">
                  {{ $t('applicationStatus') }}
                </button>
                <button
                  type="button"
                  class="details-tab"
                  :class="{ 'is-active': detailsTab === 'profile' }"
                  role="tab"
                  :aria-selected="detailsTab === 'profile' ? 'true' : 'false'"
                  @click="detailsTab = 'profile'">
                  {{ $t('applicantProfile') }}
                </button>
                <b-button
                  v-show="detailsTab === 'status'"
                  class="status-update-btn"
                  @click="saveApplicationStatus">
                  {{ $t('save') }}
                </b-button>
              </div>
            </div>
            <div class="details-tab-content">
              <job-application-status
                v-show="detailsTab === 'status'"
                ref="applicationStatus"
                :key="selectedApplicationUuid"
                :application="selectedApplication"
                @saved="onStatusSaved">
              </job-application-status>
              <job-applicant-profile
                v-show="detailsTab === 'profile'"
                :key="'profile-' + selectedApplicantId"
                :applicant-id="selectedApplicantId">
              </job-applicant-profile>
            </div>
          </template>
          <div v-else class="applicants-details-empty ace_sec_txt">
            {{ $t('selectApplicantToUpdateStatus') }}
          </div>
        </div>
      </div>
    </div>
    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
          <div class="text-center" style="color: #FFF">
              <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
          </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import JobHeader from './JobHeader'
  import JobApplicationStatus from './JobApplicationStatus'
  import JobApplicantProfile from './JobApplicantProfile'
  import '../../../assets/module/sass/course/courseList.scss'

  export default {
    name: 'jobApplicants',
    props: ['uuid'],
    components: {
      JobHeader,
      JobApplicationStatus,
      JobApplicantProfile
    },
    data: () => {
      return {
        jobApplications: [],
        pageSize: 20,
        sizeOptions: [20, 50, 100],
        firstPage: true,
        lastPage: true,
        page: 0,
        searchTerms: '',
        appliedSearch: '',
        selectedApplicationUuid: null,
        detailsTab: 'profile',
        showFiltersDropDown: false,
        showSortByDropDown: false,
        statusFilterDraft: [],
        statusFilterSelected: [],
        selectedSortName: 'Applicant',
        sorts: [
          { name: 'Applicant' },
          { name: 'Applied On' },
          { name: 'Status', labelKey: 'status' },
          { name: 'Institution' }
        ],
        statusArray: ['Applied', 'Reviewed', 'Interview Scheduled', 'Interview Done', 'Job Offered', 'Job Accepted', 'Declined'],
        statusStages: [
          { key: 'appliedOn', label: 'Applied', status: 'Applied' },
          { key: 'reviewedOn', label: 'Reviewed', status: 'Reviewed' },
          { key: 'interviewScheduledOn', label: 'Interview Scheduled', status: 'Interview Scheduled' },
          { key: 'interviewedOn', label: 'Interview Done', status: 'Interview Done' },
          { key: 'offeredOn', label: 'Job Offered', status: 'Job Offered' },
          { key: 'acceptedOn', label: 'Job Accepted', status: 'Job Accepted' }
        ],
        avatarColors: ['#5a6a7a', '#7ab8d4', '#e08a4a']
      }
    },
    mounted () {
      this.loadJobApplications()
    },
    methods: {
      ...mapActions([
        'getAllJobApplication'
      ]),
      loadJobApplications (keepPage) {
        this.showLoader()
        if (!this.uuid) {
          this.jobApplications = []
          this.updatePaging()
          this.hideLoader()
          return
        }
        this.getAllJobApplication(this.uuid).then(res => {
          this.jobApplications = this.normalizeApplications(res)
          if (!keepPage) {
            this.page = 0
          }
          this.updatePaging()
          this.syncSelectedApplication()
          this.hideLoader()
        })
      },
      normalizeApplications (res) {
        if (!res) {
          return []
        }
        if (res.content && res.content.length >= 0) {
          return res.content
        }
        if (res.length >= 0) {
          return res
        }
        if (res.status || res.userId) {
          return [res]
        }
        return []
      },
      updatePaging () {
        let totalPages = Math.ceil(this.filteredApplications.length / this.pageSize)
        if (totalPages < 1) {
          totalPages = 1
        }
        if (this.page > totalPages - 1) {
          this.page = totalPages - 1
        }
        this.firstPage = this.page <= 0
        this.lastPage = this.page >= totalPages - 1
      },
      searchButtonClicked () {
        this.appliedSearch = this.searchTerms
        this.resetPage()
      },
      toggleFiltersDropDown () {
        this.statusFilterDraft = this.statusFilterSelected.slice()
        this.showFiltersDropDown = !this.showFiltersDropDown
      },
      filtersOkClicked () {
        this.statusFilterSelected = this.statusFilterDraft.slice()
        this.showFiltersDropDown = false
        this.resetPage()
      },
      toggleSortByDropDown () {
        this.showSortByDropDown = !this.showSortByDropDown
      },
      sortOkClicked () {
        this.showSortByDropDown = false
        this.resetPage()
      },
      changeSize (option) {
        this.pageSize = option
        this.resetPage()
      },
      sortApplications (list) {
        let sorted = list.slice()
        let name = this.selectedSortName
        sorted.sort((a, b) => {
          if (name === 'Applied On') {
            return (this.applicationDate(b) || 0) - (this.applicationDate(a) || 0)
          }
          if (name === 'Status') {
            return (a.status || '').localeCompare(b.status || '')
          }
          if (name === 'Institution') {
            return (a.institutionTitle || '').localeCompare(b.institutionTitle || '')
          }
          return (a.userFullName || '').localeCompare(b.userFullName || '')
        })
        return sorted
      },
      resetPage () {
        this.page = 0
        this.updatePaging()
      },
      prev () {
        if (this.firstPage) {
          return
        }
        this.page -= 1
        this.updatePaging()
      },
      next () {
        if (this.lastPage) {
          return
        }
        this.page += 1
        this.updatePaging()
      },
      applicationDate (application) {
        if (!application) {
          return null
        }
        return application.creationTime || application.appliedTime || application.statusUpdatedTime || application.lastUpdatedTime
      },
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },
      applicationUuid (application) {
        if (!application) {
          return ''
        }
        return application.uuid || application.applicationUuid || application.applicationId || ''
      },
      applicantId (application) {
        if (!application) {
          return ''
        }
        return application.userId || application.userUuid || application.applicantId || ''
      },
      selectApplication (application) {
        this.selectedApplicationUuid = this.applicationUuid(application)
      },
      isSelected (application) {
        return this.applicationUuid(application) === this.selectedApplicationUuid
      },
      syncSelectedApplication () {
        if (!this.jobApplications || this.jobApplications.length === 0) {
          this.selectedApplicationUuid = null
          return
        }
        if (this.selectedApplicationUuid) {
          let stillVisible = this.jobApplications.some((item) => {
            return this.applicationUuid(item) === this.selectedApplicationUuid
          })
          if (!stillVisible) {
            this.selectedApplicationUuid = this.applicationUuid(this.jobApplications[0])
          }
          return
        }
        this.selectedApplicationUuid = this.applicationUuid(this.jobApplications[0])
      },
      onStatusSaved () {
        this.loadJobApplications(true)
      },
      saveApplicationStatus () {
        if (this.$refs.applicationStatus) {
          this.$refs.applicationStatus.saveStatus()
        }
      },
      statusRank (status) {
        if (status === 'Accepted') {
          status = 'Job Accepted'
        }
        if (status === 'Declined') {
          status = 'Job Offered'
        }
        let order = ['Applied', 'Reviewed', 'Interview Scheduled', 'Interview Done', 'Job Offered', 'Job Accepted']
        let index = order.indexOf(status)
        return index < 0 ? 0 : index
      },
      isOfferAccepted (application) {
        if (!application) {
          return false
        }
        return !!(application.acceptedOn || application.status === 'Accepted' || application.status === 'Job Accepted')
      },
      isOfferDeclined (application) {
        if (!application) {
          return false
        }
        return !!(application.declinedOn || application.status === 'Declined')
      },
      filterStatus (application) {
        if (!application) {
          return ''
        }
        if (this.isOfferDeclined(application)) {
          return 'Declined'
        }
        if (this.isOfferAccepted(application)) {
          return 'Job Accepted'
        }
        return application.status || ''
      },
      isStageRejected (application, stage) {
        if (!application || !stage) {
          return false
        }
        if (stage.key === 'interviewScheduledOn') {
          return !!(application.interviewRejected || application.interviewScheduleStatus === 'Rejected')
        }
        if (stage.key === 'acceptedOn') {
          return this.isOfferDeclined(application)
        }
        return false
      },
      isStageComplete (application, stage) {
        if (!application || !stage) {
          return false
        }
        if (this.isStageRejected(application, stage)) {
          return false
        }
        if (stage.key === 'acceptedOn') {
          return this.isOfferAccepted(application)
        }
        if (stage.key === 'offeredOn') {
          return !!(application.offeredOn || this.isOfferAccepted(application) || this.isOfferDeclined(application) || this.statusRank(application.status) >= this.statusRank('Job Offered'))
        }
        if (stage.key === 'appliedOn' || application[stage.key]) {
          return true
        }
        return this.statusRank(application.status) >= this.statusRank(stage.status)
      },
      stageDisplayLabel (application, stage) {
        if (!stage) {
          return ''
        }
        if (stage.key === 'acceptedOn' && this.isOfferDeclined(application)) {
          return 'Declined'
        }
        if (stage.key === 'acceptedOn' && this.isOfferAccepted(application)) {
          return 'Accepted'
        }
        return stage.label
      },
      avatarColor (index) {
        return this.avatarColors[index % this.avatarColors.length]
      },
      institutionTitle (application) {
        if (!application) {
          return ''
        }
        return application.institutionTitle || ''
      },
      institutionLogo (application) {
        if (!application) {
          return ''
        }
        return application.institutionLogo || ''
      },
      institutionInitials (title) {
        if (!title) {
          return ''
        }
        let first = title.trim().split(/\s+/)[0]
        if (first.length <= 4) {
          return first.toUpperCase()
        }
        return first.substring(0, 3).toUpperCase()
      }
    },
    computed: {
      filteredApplications () {
        let list = this.jobApplications || []
        if (this.appliedSearch) {
          let term = this.appliedSearch.toLowerCase()
          list = list.filter((application) => {
            let name = application.userFullName || ''
            let institution = application.institutionTitle || ''
            return name.toLowerCase().indexOf(term) !== -1 || institution.toLowerCase().indexOf(term) !== -1
          })
        }
        if (this.statusFilterSelected && this.statusFilterSelected.length > 0) {
          list = list.filter((application) => {
            return this.statusFilterSelected.indexOf(this.filterStatus(application)) !== -1
          })
        }
        return this.sortApplications(list)
      },
      pagedApplications () {
        let start = this.page * this.pageSize
        return this.filteredApplications.slice(start, start + this.pageSize)
      },
      selectedApplication () {
        if (!this.selectedApplicationUuid) {
          return null
        }
        let selected = this.jobApplications.find((item) => {
          return this.applicationUuid(item) === this.selectedApplicationUuid
        })
        return selected || null
      },
      selectedApplicantIndex () {
        if (!this.selectedApplicationUuid) {
          return 0
        }
        let index = this.pagedApplications.findIndex((item) => {
          return this.applicationUuid(item) === this.selectedApplicationUuid
        })
        return index < 0 ? 0 : index
      },
      selectedApplicantId () {
        return this.applicantId(this.selectedApplication)
      }
    },
    watch: {
      uuid () {
        this.loadJobApplications()
      }
    }
  }
</script>

<style scoped>
  .page_content.job-applicants-page {
    height: calc(100vh - 134px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding-right: 0;
  }

  .page_content >>> .page-heading.pg_hd {
    flex: 0 0 auto;
    margin-bottom: 0;
  }

  .course-management-section {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    margin-top: 0;
    padding: 0 0 0 20px;
    overflow: hidden;
  }

  .applicants-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 6px 20px 6px 0;
    border-bottom: 1px solid #ebebeb;
    background: #fff;
    flex-wrap: nowrap;
    flex: 0 0 auto;
  }

  .toolbar-left,
  .toolbar-right {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  }

  .applicants-filters {
    position: relative;
    margin-left: 12px;
    margin-right: 0;
    flex-shrink: 0;
  }

  .applicants-filters .form-field {
    padding: 0 10px;
    display: flex;
    align-items: center;
    border-radius: 4px;
    border: none;
    color: #000 !important;
  }

  .applicants-filters .form-field:hover,
  .applicants-filters .form-field:focus,
  .applicants-filters .form-field:active {
    color: #000 !important;
  }

  .applicants-filters .form-field .txt_sh,
  .applicants-filters .form-field .icon-dropdown1 {
    color: #000 !important;
  }

  .applicants-filters .form-field .txt_sh {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
  }

  .applicants-filters .applicant-status-filter,
  .applicants-filters .applicant-status-filter:hover,
  .applicants-filters .applicant-status-filter:focus {
    background: #7ad8f0 !important;
    color: #000 !important;
  }

  .applicants-filters .explore_filter_container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 0;
  }

  .toolbar-right .out-of-total-item {
    margin-right: 10px;
    white-space: nowrap;
  }

  .toolbar-right .number-of-item {
    margin-right: 10px;
  }

  .toolbar-right .number-of-item >>> .dropdown-toggle {
    height: 32px;
    padding: 0 12px;
    border: none;
    color: #fff;
  }

  .toolbar-right .pagination {
    display: flex;
    align-items: center;
    margin-right: 12px;
    margin-top: 0;
    padding-top: 0;
  }



  .toolbar-right .search-box-container {
    display: flex;
    align-items: center;
    width: auto;
    float: none;
  }

  .applicants-body {
    display: flex;
    align-items: stretch;
    width: 100%;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  }

  .applicants-list-pane {
    width: 30%;
    min-width: 0;
    overflow-x: hidden;
    overflow-y: auto;
    height: 100%;
    min-height: 0;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .applicants-details-pane {
    width: 70%;
    min-width: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
    min-height: 0;
    border-left: 1px solid #ebebeb;
    background: #fff;
  }

  .details-tab-content {
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .applicants-details-empty {
    padding: 24px 16px;
  }

  .details-header {
    flex: 0 0 auto;
    border-bottom: 1px solid #ebebeb;
    padding: 8px 16px 6px;
  }

  .details-tabs {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .details-applicant {
    display: flex;
    align-items: center;
    min-width: 0;
    margin: 0 0 8px;
  }

  .details-user-avatar {
    width: 28px;
    height: 28px;
    min-width: 28px;
    border-radius: 4px;
    margin-right: 10px;
  }

  .details-user-avatar .icon-user {
    font-size: 16px;
    color: #fff;
  }

  .details-applicant-name {
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .details-tab {
    height: 36px;
    padding: 0 16px;
    border: 2px solid transparent;
    border-radius: 6px;
    background: #ececec;
    color: #4a4a4a;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
    box-shadow: none;
    line-height: 32px;
  }

  .details-tab.is-active {
    border-color: rgb(21, 115, 25);
    background: #e4e4e4;
    color: #4a4a4a;
    font-weight: 400;
  }

  .details-tab:hover,
  .details-tab:focus,
  .details-tab:active {
    outline: none;
    box-shadow: none;
    background: #ececec;
    color: #4a4a4a;
  }

  .details-tab.is-active:hover,
  .details-tab.is-active:focus,
  .details-tab.is-active:active {
    background: #e4e4e4;
    border-color: rgb(21, 115, 25);
    color: #4a4a4a;
  }

  .status-update-btn {
    margin-left: auto;
    flex-shrink: 0;
  }

  .applicant-profile-pane {
    padding: 24px 16px;
  }

  .applicant-row {
    position: relative;
    padding: 16px 18px;
    margin: 0 20px 12px 16px;
    cursor: pointer;
    background: #fff;
    border: 1px solid #d4d4d4;
    border-radius: 16px;
  }

  .applicant-row:hover,
  .applicant-row:focus {
    background: #fff;
  }

  .applicant-row.is-selected,
  .applicant-row.is-selected:hover,
  .applicant-row.is-selected:focus {
    background: #f3f3f3;
  }

  .applicant-row.is-selected:after {
    content: '';
    position: absolute;
    top: 50%;
    right: -8px;
    width: 14px;
    height: 14px;
    background: #f3f3f3;
    border-top: 1px solid #d4d4d4;
    border-right: 1px solid #d4d4d4;
    transform: translateY(-50%) rotate(45deg);
    z-index: 1;
  }

  .applicant-name-row,
  .applicant-institution,
  .applicant-status-row {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .applicant-name-row {
    margin-bottom: 15px;
  }

  .applicant-institution {
    margin-bottom: 15px;
  }

  .applicant-avatar,
  .institution-avatar,
  .status-path-icon {
    width: 22px;
    height: 22px;
    min-width: 22px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .applicant-avatar {
    border-radius: 4px;
    color: #fff;
  }

  .applicant-avatar .icon-user {
    font-size: 14px;
    color: #fff;
  }

  .applicant-name,
  .institution-name {
    font-size: 16px;
    font-weight: 400;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .institution-avatar {
    border-radius: 4px;
    color: #fff;
    font-size: 8px;
    font-weight: 600;
    overflow: hidden;
  }

  .institution-avatar.has-logo {
    background: #f2f2f2;
  }

  .institution-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .status-path-icon {
    height: 22px;
  }

  .status-boxes {
    display: flex;
    align-items: center;
  }

  .status-box {
    width: 22px;
    height: 22px;
    margin-right: 6px;
    border-radius: 2px;
    background: #e6e6e6;
  }

  .status-box.is-complete {
    background: #c8e6c0;
  }

  .status-box.is-rejected {
    background: #c97a7a;
  }

  .page-content-section .left-container {
    float: none;
    width: 100%;
    max-width: 100%;
    margin-top: 0;
  }
</style>

<style>
  .page_content_container:has(.job-applicants-page) {
    overflow: hidden;
    padding-bottom: 0;
    padding-right: 0;
  }

  .job-applicants-page .explore_filter_container .popover {
    transform: none !important;
    top: 32px !important;
    margin: 0 !important;
    min-width: 240px;
    left: 0 !important;
    right: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/job/components/JobApplicants.vue